import { PartnerVisaStatus } from 'types';

export function partnerVisaStatusLabel(value: string | undefined) {
  switch (value) {
    case PartnerVisaStatus.APPLYING_DEPENDANT:
      return 'Applying as a dependant on my visa';
    case PartnerVisaStatus.APPLYING_DIFFERENT:
      return 'Applying for a different type of visa';
    case PartnerVisaStatus.READY_TO_TRAVEL_VALID:
      return 'Ready to travel with a valid UK visa';
    case PartnerVisaStatus.ALREADY_IN_UK_VALID:
      return 'Already in the UK with a valid UK visa';
    default:
      return '';
  }
}

export function partnerVisaStatusSummaryRow(value: string | undefined) {
  switch (value) {
    case PartnerVisaStatus.APPLYING_DEPENDANT:
      return 'Applying as a student’s dependant';
    case PartnerVisaStatus.APPLYING_DIFFERENT:
      return 'Applying for a different type of visa';
    case PartnerVisaStatus.READY_TO_TRAVEL_VALID:
      return 'Already has a valid UK visa';
    case PartnerVisaStatus.ALREADY_IN_UK_VALID:
      return 'Is already in the UK with a valid visa';
    default:
      return '';
  }
}
